import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_5cb724f6 from 'nuxt_plugin_head_5cb724f6' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_8589a6e2 from 'nuxt_plugin_plugin0_8589a6e2' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_8588be24 from 'nuxt_plugin_plugin1_8588be24' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_8587d566 from 'nuxt_plugin_plugin2_8587d566' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_8586eca8 from 'nuxt_plugin_plugin3_8586eca8' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_858603ea from 'nuxt_plugin_plugin4_858603ea' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_85851b2c from 'nuxt_plugin_plugin5_85851b2c' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_8584326e from 'nuxt_plugin_plugin6_8584326e' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_858349b0 from 'nuxt_plugin_plugin7_858349b0' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_858260f2 from 'nuxt_plugin_plugin8_858260f2' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_85817834 from 'nuxt_plugin_plugin9_85817834' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_2b8ef8a0 from 'nuxt_plugin_plugin10_2b8ef8a0' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_2b8e0fe2 from 'nuxt_plugin_plugin11_2b8e0fe2' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_2b8d2724 from 'nuxt_plugin_plugin12_2b8d2724' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_2b8c3e66 from 'nuxt_plugin_plugin13_2b8c3e66' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_2b8b55a8 from 'nuxt_plugin_plugin14_2b8b55a8' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_2b8a6cea from 'nuxt_plugin_plugin15_2b8a6cea' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_2b89842c from 'nuxt_plugin_plugin16_2b89842c' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_2b889b6e from 'nuxt_plugin_plugin17_2b889b6e' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_2b87b2b0 from 'nuxt_plugin_plugin18_2b87b2b0' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_2b86c9f2 from 'nuxt_plugin_plugin19_2b86c9f2' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_2b72c99e from 'nuxt_plugin_plugin20_2b72c99e' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_2b71e0e0 from 'nuxt_plugin_plugin21_2b71e0e0' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_2b70f822 from 'nuxt_plugin_plugin22_2b70f822' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_2b700f64 from 'nuxt_plugin_plugin23_2b700f64' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_2b6f26a6 from 'nuxt_plugin_plugin24_2b6f26a6' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_5cb724f6 === 'function') {
    await nuxt_plugin_head_5cb724f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_8589a6e2 === 'function') {
    await nuxt_plugin_plugin0_8589a6e2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_8588be24 === 'function') {
    await nuxt_plugin_plugin1_8588be24(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_8587d566 === 'function') {
    await nuxt_plugin_plugin2_8587d566(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_8586eca8 === 'function') {
    await nuxt_plugin_plugin3_8586eca8(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_858603ea === 'function') {
    await nuxt_plugin_plugin4_858603ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_85851b2c === 'function') {
    await nuxt_plugin_plugin5_85851b2c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_8584326e === 'function') {
    await nuxt_plugin_plugin6_8584326e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_858349b0 === 'function') {
    await nuxt_plugin_plugin7_858349b0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_858260f2 === 'function') {
    await nuxt_plugin_plugin8_858260f2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_85817834 === 'function') {
    await nuxt_plugin_plugin9_85817834(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_2b8ef8a0 === 'function') {
    await nuxt_plugin_plugin10_2b8ef8a0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_2b8e0fe2 === 'function') {
    await nuxt_plugin_plugin11_2b8e0fe2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_2b8d2724 === 'function') {
    await nuxt_plugin_plugin12_2b8d2724(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_2b8c3e66 === 'function') {
    await nuxt_plugin_plugin13_2b8c3e66(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_2b8b55a8 === 'function') {
    await nuxt_plugin_plugin14_2b8b55a8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_2b8a6cea === 'function') {
    await nuxt_plugin_plugin15_2b8a6cea(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_2b89842c === 'function') {
    await nuxt_plugin_plugin16_2b89842c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_2b889b6e === 'function') {
    await nuxt_plugin_plugin17_2b889b6e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_2b87b2b0 === 'function') {
    await nuxt_plugin_plugin18_2b87b2b0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_2b86c9f2 === 'function') {
    await nuxt_plugin_plugin19_2b86c9f2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_2b72c99e === 'function') {
    await nuxt_plugin_plugin20_2b72c99e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_2b71e0e0 === 'function') {
    await nuxt_plugin_plugin21_2b71e0e0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_2b70f822 === 'function') {
    await nuxt_plugin_plugin22_2b70f822(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_2b700f64 === 'function') {
    await nuxt_plugin_plugin23_2b700f64(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_2b6f26a6 === 'function') {
    await nuxt_plugin_plugin24_2b6f26a6(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
